import axios from "axios";
import { pgApiError } from "../components/mixPanelEvents/mixPanelEvents";

const token = process.env.REACT_APP_ACCESS_TOKEN || "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NTMwMTExNzQsInN1YiI6MX0.0ccrpvLDo5Qp-ASo6j_pLN9LZiVj2vKZpPmot8AHBho";

// Determine which authentication type to use - default is 'wp-nonce'
const authType = process.env.REACT_APP_AUTH_TYPE || 'wp-nonce';

// Build headers based on authentication type
const buildHeaders = () => {
    const headers = {};
    
    if (authType === 'bearer') {
        headers['Authorization'] = `Bearer ${token}`;
    } else {
        // Default to X-WP-Nonce
        headers['X-WP-Nonce'] = window.apiSettings?.nonce;
    }
    
    
    return headers;
};

const config = {
    baseUrl: process.env.REACT_APP_BASE_URL || '/',
    // baseUrl:'http://localhost:10003',
    withCredentials: true,
};


const base = async param => {
    return await axios({
        method: param.method,
        baseURL: config.baseUrl,
        url: param.url,
        headers: buildHeaders(),
        data: param.data,
    })
        .then(res => {
            return Promise.resolve(res);
        })
        .catch(err => {
            if (err.response) {
                pgApiError({
                    Type: "axios",
                    Url: param.url,
                    Response: err.response
                });
                return Promise.reject(err.response);
            } else {
                pgApiError({
                    Type: "axios",
                    Url: param.url,
                    Response: "TIMEOUT"
                });
                return Promise.reject('TIMEOUT');
            }
        });
};

export const axiosRequest = async (method, url) => {
    return await base({method, url})
        .then(res => Promise.resolve(res))
        .catch(err => Promise.reject(err));
};

export const axiosRequestData = async (method, url, data) => {
    return await base({method, url, data})
        .then(res => Promise.resolve(res))
        .catch(err => Promise.reject(err));
};